import React, {useEffect, useState} from 'react';
import PubSub from 'services/PubSub/';
import Drawer from "components/Drawers/Drawer";
import ClientUpdate from 'components/Drawers/DrawerClientUpdate/ClientUpdate';
import { actionsType } from 'config/constants';
import NewRelicService from 'services/NewRelic'
import style from './style.scss'; //NOSONAR

let actions = [];
let callbackGoBack = () => {}

const DrawerClientUpdate = () => {
    const [payload, setPayload] = useState(null);

    useEffect(() => {
        actions.push(PubSub.register(actionsType.DRAWER.UPDATE_CLIENT_OPEN, _openInfo));
        actions.push(PubSub.register(actionsType.DRAWER.UPDATE_CLIENT_CLOSE, _closeInfo));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const _closeInfo = () =>{
        if(callbackGoBack){
            callbackGoBack();
        }
    }

    const _openInfo = (_payload) => {
        if (_payload.value.callbackGoBack){
            callbackGoBack = _payload.value.callbackGoBack; 
        }

        setPayload(_payload)

        NewRelicService.sendPageAction({
            action: 'updateClientOpen'
        })
    }

    return (
        <Drawer customClass={'drawer-client-update'} actionOpen={actionsType.DRAWER.UPDATE_CLIENT_OPEN} actionClose={actionsType.DRAWER.UPDATE_CLIENT_CLOSE}>
            {payload && <ClientUpdate payload={payload}/>}
        </Drawer>
    );
}

export default DrawerClientUpdate;